import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import EventLogApi from "api/eventLogApi";
import { formatQueryParams } from "helpers/format";

export const getEventLogs = createAsyncThunk(
  "EventLogs",
  async (params: any = {}) => {
    try {
      const response = await EventLogApi.eventLogs(formatQueryParams(params));
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getEventLogsNew = createAsyncThunk(
  "EventLogsNew",
  async (params: any = {}) => {
    try {
      const response = await EventLogApi.eventLogsNew(formatQueryParams(params));
      return response;
    } catch (error) {
      return error;
    }
  }
);
